module.exports = __webpack_public_path__ + "static/media/kids_la.db583b68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/kids_la.jpg
// module id = 452
// module chunks = 0